var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "editor-layout-selector-view" },
    [
      _c(
        "div",
        { staticClass: "editor-layout-view-category-container" },
        [
          !_vm.isMobile
            ? _c("SelectComponent", {
                attrs: {
                  multiple: true,
                  options: _vm.computedLayoutOptions,
                  padding: [16, 24],
                  width: _vm.computedWidth,
                  color: "secondary",
                  height: "auto",
                  theme: "light",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (selectComponentProps) {
                        return [
                          _vm._v(
                            _vm._s(_vm.computedLayoutText(selectComponentProps))
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  976444352
                ),
                model: {
                  value: _vm.layoutCategories,
                  callback: function ($$v) {
                    _vm.layoutCategories = $$v
                  },
                  expression: "layoutCategories",
                },
              })
            : _vm._e(),
          _vm.isMobile
            ? _c(
                "ButtonToggleComponent",
                {
                  attrs: { checked: _vm.layoutCategories.length === 0 },
                  on: { change: _vm.onAllLayoutsChange },
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.$t("views.editorLayoutSelector.all.mobile", {
                        count: _vm.layoutsToShow.length,
                      })
                    )
                  ),
                ]
              )
            : _vm._e(),
          _vm._l(_vm.computedLayoutOptions, function (layoutOption) {
            return _vm.isMobile
              ? _c(
                  "ButtonToggleComponent",
                  {
                    key: layoutOption.value,
                    attrs: {
                      "can-toggle": true,
                      checked: _vm.layoutCategories.includes(
                        layoutOption.value
                      ),
                      value: layoutOption.value,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.onLayoutCategoryChange(layoutOption, $event)
                      },
                    },
                  },
                  [_vm._v(_vm._s(layoutOption.title))]
                )
              : _vm._e()
          }),
        ],
        2
      ),
      _c(
        "ButtonToggleGroupComponent",
        {
          staticClass: "editor-layout-selector-view-layouts",
          style: _vm.computedStyles,
          attrs: {
            value: _vm.internalValue ? _vm.internalValue.id : undefined,
          },
          on: { change: _vm.onChange },
        },
        _vm._l(_vm.layoutsToShow, function (layout) {
          return _c("ButtonToggleComponent", {
            key: layout.id,
            style: _vm.computedLayoutStyles,
            attrs: { value: layout.id, variant: "big" },
            scopedSlots: _vm._u(
              [
                {
                  key: "content",
                  fn: function () {
                    return _vm._l(layout.positions, function (position) {
                      return _c(
                        "div",
                        {
                          key: position.id,
                          staticClass: "editor-layout-selector-view-position",
                          style: _vm.getPositionStyles(position),
                        },
                        [_vm._v(_vm._s(_vm.getPositionContent(position)))]
                      )
                    })
                  },
                  proxy: true,
                },
              ],
              null,
              true
            ),
          })
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }